import React from 'react';
import "./AvvisiToolbar.css";
import TextLabel from "../../../Controls/TextLabel.mjs";
import WritenewIcon from "../../../media/images/WritenewIcon.mjs";
import Glob from "../../../libs/Glob.mjs";
import MailIcon from "../../../media/images/MailIcon.mjs";

const AvvisiToolbar = class extends React.Component {
	constructor(props) {
		super(props);
		const s = Glob.getStatus('Scenario');
		this.state = {
			mailbox: s?.mailbox,
			telegram: s?.telegram
		};
		this.uid = Glob.generateUid('MailToolbar');
	}
	componentDidMount() {
		Glob.register('Scenario', s=> {
			this.setState({
				mailbox: s?.mailbox,
				telegram: s?.telegram
			});
		}, this.uid);
	}
	componentWillUnmount() {
		Glob.unregister('Scenario',this.uid);
	}
	render() {
		return (
			<div className={"AppToolbar AvvisiToolbar"} id={this.uid}>
				<div className={"info nomobile"}>
					<MailIcon />
					<span>{ this.state.mailbox }</span>
				</div>
				<div className={"ToolbarButtonbar"}>
					<div
						className={"ToolbarButton gameRunning"}
						onClick={e => {
							e.preventDefault();
							Glob.trigger('WriteNewAvviso')
						}}
					>
						<WritenewIcon/>
						<span className={"nomobile"}>
							<TextLabel value={"New notice"}/>
						</span>
					</div>
				</div>
			</div>
		);
	}
}

export default AvvisiToolbar;